import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center",
  role: "alert",
  style: {"position":"fixed","bottom":"0","left":"0","right":"0","margin-bottom":"0","z-index":"9999999999"}
}
const _hoisted_2 = {
  key: 1,
  class: "text-center",
  role: "alert",
  style: {"position":"fixed","bottom":"0","left":"0","right":"0","margin-bottom":"0","z-index":"9999999999"}
}

import {ref, onBeforeMount, onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import Config from '../service/Config';
import EventManager from '../service/AppEventManagerService';
import flashMessenger from "../service/FlashMessenger";
import { useStore } from 'vuex';
import securityService from "../service/SecurityService";
import axios from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'VersionComponent',
  setup(__props) {


const route = ref<any>(useRoute());
const router = ref<any>(useRouter());
const store = ref(useStore());
const v = ref('0.0.0');
const config = ref(Config);
const eventManager = ref(EventManager);
const latestVersion = ref(config.value.version);
const username = ref<any>(store.value.getters.getAdminEmail);
const adminAccountId = ref();
const currentRouteName = ref();
const noInternetConnection = ref(false);
const isOwner = ref(null);
const me = ref();

onBeforeMount(async() => {
  eventManager.value.on('auth.signin' , async () => {
    await load();
  });
  eventManager.value.on('auth.signout-post', async ()=> {
    await checkUser();
    window.location.href = '/signin';
  });
})

onMounted(async() => {
  await load ();
})

async function load () {
  currentRouteName.value = router.value.currentRoute.path;
  setInterval(() => {
    flashMessenger.refresh();
  }, 500);
  store.value.subscribe((mutation:any, state:any) => {
    if (mutation.type == 'setAdminEmail') {
      username.value = state.adminEmail;
    }
  })
  me.value = await securityService.me();
  adminAccountId.value = me.value ? me.value.accountId: '';

  await checkUser();
  const versionChars = [];
  if (config.value.version < 100) {
    versionChars.push(0);
  }
  for (let c of config.value.version) {
    versionChars.push(c);
  }
  v.value = versionChars.join('.');

  let check = async () => {
    let ts = Math.round(new Date().getTime() / 1000);
    const response = await axios.get('version.json?t=' + ts);
    let version = response.data;
    latestVersion.value = version.current;
    if (version.min > config.value.version) {
      window.location.reload();
    }
  }
  await check();
  setInterval(check, 5 * 60 * 1000);

  window.addEventListener("offline", () => {
    noInternetConnection.value = true;
  }, false);

  window.addEventListener("online", () => {
    noInternetConnection.value = false;
  }, false);
}

async function checkUser() {
  const response = await securityService.getUser();
  if (!response || response.error) {
    me.value = null;
    config.value.crFormat = 'minimal';
  } else {
    me.value = response.admin[0];
    config.value.crFormat = 'normal';
    if (me.value.username != username.value) {
      store.value.commit('setAdminEmail', me.value.username);
    }
    isOwner.value = securityService.isOwner();
  }
}

function reloadNow() {
  window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (noInternetConnection.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_alert, {
            density: "comfortable",
            class: "alertStyle"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("strong", { style: {"color":"#721c24"} }, "No Internet Connection!", -1 /* CACHED */)),
              _createVNode(_component_v_btn, {
                variant: "flat",
                size: "small",
                color: "#424242",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (reloadNow())),
                class: "text-none ml-2"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Reload now", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    (latestVersion.value > config.value.version)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_alert, {
            density: "comfortable",
            class: "alertStyle"
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("strong", { style: {"color":"#721c24"} }, "New version of CodeREADr is available!", -1 /* CACHED */)),
              _createVNode(_component_v_btn, {
                variant: "flat",
                size: "small",
                color: "#424242",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (reloadNow())),
                class: "text-none ml-2"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Reload now", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})